var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdiCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:certificate"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.33342 6.25C6.02091 6.25 4.16675 8.10417 4.16675 10.4167V31.25C4.16675 32.3551 4.60573 33.4149 5.38714 34.1963C6.16854 34.9777 7.22835 35.4167 8.33342 35.4167H25.0001V45.8333L31.2501 39.5833L37.5001 45.8333V35.4167H41.6668C42.7718 35.4167 43.8316 34.9777 44.613 34.1963C45.3944 33.4149 45.8334 32.3551 45.8334 31.25V10.4167C45.8334 9.3116 45.3944 8.25179 44.613 7.47039C43.8316 6.68899 42.7718 6.25 41.6668 6.25H8.33342ZM25.0001 10.4167L31.2501 14.5833L37.5001 10.4167V17.7083L43.7501 20.8333L37.5001 23.9583V31.25L31.2501 27.0833L25.0001 31.25V23.9583L18.7501 20.8333L25.0001 17.7083V10.4167ZM8.33342 10.4167H18.7501V14.5833H8.33342V10.4167ZM8.33342 18.75H14.5834V22.9167H8.33342V18.75ZM8.33342 27.0833H18.7501V31.25H8.33342V27.0833Z",
    fill: "#794BFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiCertificate);
export default __webpack_public_path__ + "static/media/mdi_certificate.b15b71b677dd19f61182707f40672472.svg";
export { ForwardRef as ReactComponent };